(function () {
  'use strict';
  if (window.csSearchCategoryRotation) return;
  window.csSearchCategoryRotation = true;
  function init() {
    var form = document.querySelector('.mobile-search-host .header-search form.search-bar');
    if (!form) return;
    var input = form.querySelector('input[name="q"]');
    if (!input) return;
    var categories = Array.from(document.querySelectorAll('#header_search_result .hot_search_list a')).map(function (link) {
      return { title: link.textContent.trim(), url: new URL(link.href, window.location.origin) };
    }).filter(function (category) {
      return category.title && category.url.origin === window.location.origin;
    });
    if (!categories.length) return;
    var desktop = window.matchMedia('(min-width: 1025px)');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var original = input.getAttribute('placeholder') || '';
    var index = 0;
    function active() { return desktop.matches && !input.value.trim(); }
    function render() {
      input.setAttribute('placeholder', active() ? categories[index].title : original);
    }
    form.addEventListener('input', render);
    desktop.addEventListener('change', render);
    // Capture before legacy submit/history listeners. Never intercept a typed query.
    form.addEventListener('submit', function (event) {
      if (!active()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      var url = new URL(categories[index].url.href);
      var preview = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      window.location.assign(url.href);
    }, true);
    render();
    window.setInterval(function () {
      if (!active() || document.hidden || reducedMotion.matches) return;
      index = (index + 1) % categories.length;
      render();
    }, 3500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
